package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.css.accentColor
import com.varabyte.kobweb.compose.css.transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.tabIndex
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.wordBreak
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement

@Composable
fun CheckboxComponent(
    modifier:Modifier=Modifier,
    checkStatus:Boolean,
    title:String,
    fontWeight: FontWeight=FontWeight.Normal,
    onUnChecked:()->Unit,
    enabled:Boolean=true,
    accentColor:CSSColorValue= Theme.PrimaryMain.rgb,
    onChecked:()->Unit,
)
{
    val isChecked= remember { mutableStateOf(checkStatus) }
    val isHovered= remember { mutableStateOf(false) }
    val isFocused= remember { mutableStateOf(false) }


    LaunchedEffect(key1 = checkStatus) {
        isChecked.value = checkStatus
    }
    Row(
        modifier = modifier
            .onMouseOver {isHovered.value=true}
            .onMouseLeave { isHovered.value=false }
            .onFocusIn { isFocused.value = true }
            .onFocusOut { isFocused.value = false }
            .onClick { event: SyntheticMouseEvent ->
                event.stopPropagation()
                if (enabled) {
                    isChecked.value = !isChecked.value
                    if (isChecked.value) {
                        onChecked()
                    } else {
                        onUnChecked()
                    }
                }
            },
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        Box(
            modifier = Modifier
                .size(Dimen.checkBoxParentSize)
                .tabIndex(0)
                .borderRadius(50.percent)
                .backgroundColor(
                    if (!enabled){
                        Theme.Transparent.rgb
                    }else{
                        if (isFocused.value){
                            if (isChecked.value)
                                Theme.PrimaryStatesFocus.rgb
                            else Theme.ActionFocused.rgb
                        }else{
                            if (isHovered.value){
                                if (isChecked.value)
                                    Theme.PrimaryStatesHover.rgb
                                else Theme.ActionHover.rgb
                            }
                            else Theme.Transparent.rgb
                        }
                    }

                ),
            contentAlignment = Alignment.Center
        )
        {
            Input(type = InputType.Checkbox,
                attrs = {
                    if (!enabled)
                        disabled()
                    checked(isChecked.value)
                    onFocus { isFocused.value = true }
                    onBlur { isFocused.value = false }
                    style {
                        accentColor(
                            if (enabled) accentColor
                            else Theme.TextDisabled.rgb
                        )
                        width(Dimen.checkBoxSize)
                        height(Dimen.checkBoxSize)
                        property("transform",
                            "scale(0.75)")
                        if (!isChecked.value) {
                            property("border",
                                "2.5px solid ${Theme.TextSecondary.hex}")
                        }

                        transition(
                            Transition.of(
                                property = "all",
                                duration = Constants.fastTransition
                            )
                        )
                    }
                })
        }

        SpanText(
            text = title,
            modifier = Modifier
                .margin(0.px)
                .cursor(Cursor.Pointer)
                .fontSize(FontSizes.mediumFontSize)
                .fontWeight(fontWeight)
                .whiteSpace(WhiteSpace.Normal)
                .wordBreak(WordBreak.Normal)
                .fontFamily(FontFamily.Jakarta)
                .color(
                    if (enabled)
                        Theme.TextPrimary.rgb
                    else Theme.TextDisabled.rgb
                )
        )
    }
}